import { SecurityEffect } from 'src/app/admin/security-groups/store/effects/security.effect';

export const SecurityGroupsEffects = [SecurityEffect];
